<header class="header-container" role="banner">
  <button class="header-left" (click)="homeRedirection()" aria-label="Navigate to home page" title="Home">
    <img src="/assets/images/PPLhome_logo.png" alt="PPL First Logo" class="logo" />
  </button>


  <div class="header-center" role="region" aria-label="Program location">
  </div>

  <div class="header-right" role="region" aria-label="Navigation and user account">
    @if (selectedProgram) {
    <div class="city" title="{{selectedProgram}}" role="status">
      <img class="header-icon" src="/assets/images/location_on_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24.svg" alt="Program location icon"/>
      <div class="cityName">{{selectedProgram}}</div>
    </div>
    <div class="program-divider"></div>
    }
    <div class="d-flex align-items-center gap-3 mr-3">
      @if(menuItemstoDisplay && !disableMenu && isInternalApp){
      <ppl-menu-drop-button [menuItems]="menuItemstoDisplay" label="Menu"
        icon="/assets/images/add_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg" [customClass]="'menu-drop-button'"
        [iconPosition]="'right'" aria-label="Open application menu"></ppl-menu-drop-button>
      }
      @if(selectedProgram) {
        <div class="header-tooltip" data-tooltip="Notifications" aria-label="Notifications">
          <ppl-notifications
            [notifications]="notifications"
            [userType]="userDetails?.usertype_lkp"
            (viewAllClick)="viewAllNotifications()"
            aria-label="Notifications">
          </ppl-notifications>
        </div>
      }
    </div>
    @if (userDetails) {
    <div class="user-info" role="status" aria-live="polite">
      <div class="user-name">{{userDetails.last_name ? userDetails.last_name+',': ''}} {{userDetails.first_name}}</div>
      <div class="user-role">
        @if(selectedRoleName) {
          {{selectedRoleName}}
        }
      </div>
    </div>
    }
    <button class="logout-btn" (click)="logout()" aria-label="Logout from application" title="Logout">
      <i class="fa fa-sign-out header-icon" aria-hidden="true"></i>
      <span class="logout-text">Logout</span>
    </button>
  </div>
</header>